export default function (networkId) {
  switch (networkId) {
    case 0:
      return "";
    case 1:
      return "CJ";
    case 2:
      return "LS";
    case 3:
      return "";
    case 4:
      return "AM";
    case 5:
      return "SAS";
    case 6:
      return "PJ";
    case 7:
      return "INDY";
    case 8:
      return "EBY";
    case 9:
      return "AL";
    case 10:
      return "ON";
    case 11:
      return "AF";
    case 12:
      return "ON";
    case 13:
      return "IR";
    case 14:
      return "LC";
    case 15:
      return "WG";
    case 16:
      return "AW";
    default:
      return "";

  }
}
